import { render } from "./InStorageRecordDetail.vue?vue&type=template&id=0fe01024&scoped=true"
import script from "./InStorageRecordDetail.vue?vue&type=script&lang=js"
export * from "./InStorageRecordDetail.vue?vue&type=script&lang=js"

import "./InStorageRecordDetail.vue?vue&type=style&index=0&id=0fe01024&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe01024"]])

export default __exports__